export default {
  hasNewNotificationMessages: null
}
